export default {"src":"/_next/static/media/math.4c786ed4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};